import { HStack, Text, TextProps, useTheme } from '@wegroup/design-system';
import React from 'react';
import { handleResponseLanguage } from '../../../../../../../i18n';
import { useFlowsSelector } from '../../../../../../common/src/utils/globalVariables';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { parseStringForAnswers } from '../../../../utils/stringUtils';

interface Props {
  question: FlowsQuestion;
}

const FlowsQuestionText: React.FC<Props & TextProps> = ({
  question,
  ...otherProps
}) => {
  const answers = useFlowsSelector((state) => state.flows.answers);
  const translatedText = handleResponseLanguage(question.title);
  const { colors, space } = useTheme();

  return (
    <HStack spacing="1">
      <Text
        {...otherProps}
        as="span"
        dangerouslySetInnerHTML={{
          __html: `${parseStringForAnswers({
            answers,
            question: translatedText,
            bold: true,
            index: question.index,
          })}${
            translatedText && question.rules.mandatory
              ? `<span style="color:${colors.danger.main};margin-left:${space[1]};">*</span>`
              : ''
          }`,
        }}
      />
    </HStack>
  );
};

export default FlowsQuestionText;
